export default function isPropControlled(prop: unknown) {
  return prop !== undefined;
}
